export default __webpack_public_path__ + "static/mongodb-9ba3aeae5c9687f97692d607e3c9ccc3.svg";